export const INVOICE_TAGS = {
    INVOICE_DETAILS: "getInvoiceDetails",
    INVOICE_BY_AUCTION_ID: "GetInvoiceByAuctionId",
} as const;